import React from 'react';
import {MasterLayout} from 'components/layouts';
import {DaNangBusiness} from 'components/business/danang-business';
import title from 'constants/TitlePages.js';

class DaNangBusinessPage extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  componentDidMount() {
    document.title = title.DaNangBusinessPage;
  }

  render() {
    return (
      <MasterLayout>
        <DaNangBusiness/>
      </MasterLayout>
    );
  }
}

export default DaNangBusinessPage;



// WEBPACK FOOTER //
// ./pages/businesses/DaNangBusinessPage.jsx